import { EsteiraTech } from '../esteiratech';

const storageKeys = {
    email: 'loginEmail',
    remember: 'loginRemember',
};

function getElement(id) {
    return document.getElementById(id);
}

function restoreLoginData() {
    const emailInput = getElement('email');
    const rememberInput = getElement('remember');

    if (!emailInput || !rememberInput) {
        return;
    }

    const savedEmail = localStorage.getItem(storageKeys.email);
    const shouldRemember = localStorage.getItem(storageKeys.remember) === '1';

    if (savedEmail) {
        emailInput.value = savedEmail;
    }

    rememberInput.checked = shouldRemember;
}

function saveLoginData() {
    const emailInput = getElement('email');
    const rememberInput = getElement('remember');

    if (!emailInput || !rememberInput) {
        return;
    }

    if (!rememberInput.checked) {
        localStorage.removeItem(storageKeys.email);
        localStorage.removeItem(storageKeys.remember);
        return;
    }

    localStorage.setItem(storageKeys.email, emailInput.value.trim());
    localStorage.setItem(storageKeys.remember, '1');
}

function bindLoginStorage() {
    const emailInput = getElement('email');
    const rememberInput = getElement('remember');

    emailInput?.addEventListener('input', saveLoginData);
    rememberInput?.addEventListener('change', saveLoginData);
}

function bindPasswordToggles() {
    document.querySelectorAll('[data-password-toggle]').forEach((toggleButton) => {
        const targetId = toggleButton.getAttribute('data-target');
        const passwordInput = targetId ? getElement(targetId) : null;

        if (!passwordInput) {
            return;
        }

        toggleButton.addEventListener('click', () => {
            const isVisible = passwordInput.type === 'text';

            passwordInput.type = isVisible ? 'password' : 'text';
            toggleButton.classList.toggle('is-visible', !isVisible);
            toggleButton.setAttribute('aria-pressed', String(!isVisible));
            toggleButton.setAttribute('aria-label', isVisible ? 'Mostrar senha' : 'Ocultar senha');
        });
    });
}

function bindDocumentMasks() {
    document.querySelectorAll('[data-cpf-mask]').forEach((input) => {
        input.addEventListener('input', (event) => {
            let value = event.target.value.replace(/\D/g, '').slice(0, 11);

            value = value.replace(/(\d{3})(\d)/, '$1.$2');
            value = value.replace(/(\d{3})(\d)/, '$1.$2');
            value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2');

            event.target.value = value;
        });
    });

    document.querySelectorAll('[data-phone-mask]').forEach((input) => {
        input.addEventListener('input', (event) => {
            let value = event.target.value.replace(/\D/g, '').slice(0, 11);

            value = value.replace(/^(\d{2})(\d)/, '($1) $2');
            value = value.replace(/(\d)(\d{4})$/, '$1-$2');

            event.target.value = value;
        });
    });
}

function bindFileNames() {
    document.querySelectorAll('input[type="file"]').forEach((input) => {
        input.addEventListener('change', () => {
            const file = input.files?.[0] || null;
            const target = document.querySelector(`[data-file-name="${input.id}"]`);

            if (target) {
                target.textContent = file?.name || '';
            }

            if (input.id !== 'profile_photo') {
                return;
            }

            const preview = document.querySelector('[data-photo-preview]');
            const previewWrapper = preview?.closest('.cz-photo-preview');

            if (!preview || !previewWrapper) {
                return;
            }

            if (!file) {
                preview.src = '';
                preview.hidden = true;
                previewWrapper.classList.remove('has-image');
                return;
            }

            preview.src = URL.createObjectURL(file);
            preview.hidden = false;
            previewWrapper.classList.add('has-image');
        });
    });
}

function onlyDigits(value) {
    return String(value || '').replace(/\D/g, '');
}

function isValidCpf(value) {
    const cpf = onlyDigits(value);

    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) {
        return false;
    }

    for (let position = 9; position < 11; position += 1) {
        let sum = 0;

        for (let index = 0; index < position; index += 1) {
            sum += Number(cpf[index]) * ((position + 1) - index);
        }

        const digit = ((10 * sum) % 11) % 10;

        if (Number(cpf[position]) !== digit) {
            return false;
        }
    }

    return true;
}

function passwordState(value, showValidation = false) {
    const password = String(value || '');
    const hasMinLength = password.length >= 6;
    const hasLetter = /[A-Za-zÀ-ÿ]/.test(password);
    const hasNumber = /\d/.test(password);
    const isValid = hasMinLength && hasLetter && hasNumber;

    let strength = 'empty';
    let message = 'Use pelo menos 6 caracteres com letras e números.';

    if (password.length > 0 && !isValid) {
        strength = 'weak';
        message = showValidation ? 'A senha precisa ter pelo menos 6 caracteres, com letras e números.' : 'Senha fraca. Use letras e números.';
    }

    if (isValid) {
        strength = password.length >= 10 ? 'strong' : 'good';
        message = password.length >= 10 ? 'Senha forte.' : 'Senha válida.';
    }

    return { isValid, strength, message };
}

function updatePasswordMeter(showValidation = false) {
    const passwordInput = getElement('password');
    const meter = document.querySelector('[data-kt-password-meter-control="highlight"]');
    const text = document.querySelector('[data-password-meter-text]');

    if (!passwordInput || !meter || !text) {
        return;
    }

    const state = passwordState(passwordInput.value, showValidation);

    meter.setAttribute('data-password-strength', state.strength);
    text.textContent = state.message;
    text.classList.toggle('is-invalid', showValidation && passwordInput.value.length > 0 && !state.isValid);
    text.classList.toggle('is-valid', state.isValid);
}
function getValidationTarget(input) {
    return input.closest('.cz-auth-field') || input.closest('.cz-upload-field') || input.closest('.cz-auth-check')?.parentElement || input.parentElement;
}

function getVisualTarget(input) {
    if (input.type === 'file') {
        return document.querySelector(`label[for="${input.id}"]`);
    }

    if (input.type === 'checkbox') {
        return input.closest('.cz-auth-check');
    }

    return input.closest('.cz-auth-input-group');
}

function getDynamicError(input) {
    const target = getValidationTarget(input);

    if (!target) {
        return null;
    }

    let error = target.querySelector('[data-dynamic-error]');

    if (!error) {
        error = document.createElement('span');
        error.className = 'cz-auth-error';
        error.setAttribute('data-dynamic-error', 'true');
        target.appendChild(error);
    }

    return error;
}

function shouldShowFeedback(input) {
    const form = input.closest('[data-broker-registration-form]');

    return input.dataset.touched === 'true' || form?.dataset.submitted === 'true';
}

function setFieldState(input, message = '', options = {}) {
    const showFeedback = options.showFeedback ?? shouldShowFeedback(input);
    const useDynamicError = options.useDynamicError ?? true;
    const visualTarget = getVisualTarget(input);
    const error = useDynamicError ? getDynamicError(input) : null;
    const hasValue = Boolean(input.value || input.checked || input.files?.length);
    const shouldDisplayState = showFeedback && hasValue;

    input.setCustomValidity(message);

    visualTarget?.classList.toggle('is-invalid', showFeedback && Boolean(message));
    visualTarget?.classList.toggle('is-valid', shouldDisplayState && !message);

    if (error) {
        error.textContent = showFeedback ? message : '';
        error.hidden = !showFeedback || !message;
    }

    return !message;
}

function validateInput(input) {
    const value = String(input.value || '').trim();

    if (input.disabled || input.closest('.is-hidden')) {
        return setFieldState(input);
    }

    switch (input.dataset.validate) {
        case 'name':
            return setFieldState(input, value.length < 2 || !/^[\p{L}\s'-]+$/u.test(value) ? 'Informe um nome válido.' : '');

        case 'lastName':
            return setFieldState(input, value.length < 2 || !/^[\p{L}\s'-]+$/u.test(value) ? 'Informe um sobrenome válido.' : '');

        case 'telefone':
            return setFieldState(input, !/^\d{10,11}$/.test(onlyDigits(value)) ? 'Informe um telefone válido com DDD.' : '');

        case 'email':
            return setFieldState(input, !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? 'Informe um e-mail válido.' : '');

        case 'cpf':
            return setFieldState(input, !isValidCpf(value) ? 'Informe um CPF válido.' : '');

        case 'creci_number':
            return setFieldState(input, !/^(?:\d{1,10}|[A-Za-z]{2}-\d{1,10}|[Ee]-\d{1,10})$/.test(value) ? 'Use 12345, RJ-12345 ou E-12345.' : '');

        case 'creci_type':
            return setFieldState(input, !['D', 'E', 'P'].includes(value) ? 'Selecione o tipo do CRECI.' : '');

        case 'creci_expires_at': {
            const creciType = getElement('creci_type')?.value;

            if (!['E', 'P'].includes(creciType)) {
                return setFieldState(input);
            }

            const today = new Date();
            const selectedDate = value ? new Date(`${value}T00:00:00`) : null;

            today.setHours(0, 0, 0, 0);

            return setFieldState(input, !selectedDate || selectedDate < today ? 'Informe uma validade atual ou futura.' : '');
        }

        case 'password': {
            const showFeedback = shouldShowFeedback(input);
            const state = passwordState(value, showFeedback);

            updatePasswordMeter(showFeedback);

            return setFieldState(input, !state.isValid ? 'A senha precisa ter pelo menos 6 caracteres, com letras e números.' : '', {
                showFeedback,
                useDynamicError: false
            });
        }

        case 'password_confirmation': {
            const password = getElement('password')?.value || '';

            if (!value) {
                return setFieldState(input, 'Confirme sua senha.');
            }

            return setFieldState(input, value !== password ? 'A confirmação da senha não confere.' : '');
        }

        case 'creci_document': {
            const file = input.files?.[0];

            if (!file) {
                return setFieldState(input);
            }

            const isAllowedType = ['application/pdf', 'image/jpeg', 'image/png'].includes(file.type);
            const isAllowedSize = file.size <= 4 * 1024 * 1024;

            if (!isAllowedType) {
                return setFieldState(input, 'Envie um arquivo PDF, JPG ou PNG.');
            }

            return setFieldState(input, !isAllowedSize ? 'O documento CRECI deve ter no máximo 4MB.' : '');
        }

        case 'profile_photo': {
            const file = input.files?.[0];

            if (!file) {
                return setFieldState(input);
            }

            const isAllowedType = ['image/jpeg', 'image/png', 'image/webp'].includes(file.type);
            const isAllowedSize = file.size <= 2 * 1024 * 1024;

            if (!isAllowedType) {
                return setFieldState(input, 'Envie uma foto JPG, PNG ou WEBP.');
            }

            return setFieldState(input, !isAllowedSize ? 'A foto de perfil deve ter no máximo 2MB.' : '');
        }

        case 'terms':
            return setFieldState(input, !input.checked ? 'Confirme a declaração para continuar.' : '');

        default:
            return true;
    }
}

function toggleCreciExpiration() {
    const creciType = getElement('creci_type');
    const expirationField = document.querySelector('[data-creci-expiration-field]');
    const expirationInput = getElement('creci_expires_at');

    if (!creciType || !expirationField || !expirationInput) {
        return;
    }

    const shouldShow = ['E', 'P'].includes(creciType.value);

    expirationField.classList.toggle('is-hidden', !shouldShow);
    expirationField.setAttribute('aria-hidden', String(!shouldShow));
    expirationInput.required = shouldShow;

    if (!shouldShow) {
        expirationInput.value = '';
        setFieldState(expirationInput);
    }
}

function validateBrokerForm(form) {
    const inputs = Array.from(form.querySelectorAll('[data-validate]'));
    const isValid = inputs.every((input) => validateInput(input));

    if (!isValid) {
        const firstInvalid = inputs.find((input) => !input.checkValidity());

        firstInvalid?.focus({ preventScroll: false });
    }

    return isValid;
}

function bindBrokerRegistrationValidation() {
    const form = document.querySelector('[data-broker-registration-form]');

    if (!form) {
        return;
    }

    toggleCreciExpiration();
    updatePasswordMeter(false);

    form.querySelectorAll('[data-validate]').forEach((input) => {
        input.addEventListener('input', () => {
            if (input.id === 'password') {
                updatePasswordMeter(shouldShowFeedback(input));

                const confirmation = getElement('password_confirmation');

                if (confirmation?.dataset.touched === 'true' || form.dataset.submitted === 'true') {
                    validateInput(confirmation);
                }

                validateInput(input);
                return;
            }

            if (input.dataset.touched === 'true' || form.dataset.submitted === 'true') {
                validateInput(input);
            }
        });

        input.addEventListener('blur', () => {
            input.dataset.touched = 'true';
            validateInput(input);
        });

        input.addEventListener('change', () => {
            if (input.id === 'creci_type') {
                input.dataset.touched = 'true';
                toggleCreciExpiration();
                validateInput(input);
                validateInput(getElement('creci_expires_at'));
                return;
            }

            if (input.type === 'file' || input.type === 'checkbox') {
                input.dataset.touched = 'true';
                validateInput(input);
                return;
            }

            if (input.dataset.touched === 'true' || form.dataset.submitted === 'true') {
                validateInput(input);
            }
        });
    });

    form.addEventListener('submit', (event) => {
        form.dataset.submitted = 'true';

        if (!validateBrokerForm(form)) {
            event.preventDefault();
            event.stopPropagation();
        }
    });
}

EsteiraTech.startPage('auth', () => {
    restoreLoginData();
    bindLoginStorage();
    bindPasswordToggles();
    bindDocumentMasks();
    bindFileNames();
    bindBrokerRegistrationValidation();
});
